export default __webpack_public_path__ + "static/media/ticket.b354d367.svg";